module.exports = __webpack_public_path__ + "img/logo.b7e60d93.png";